import { all, select, takeLatest, call, put, delay } from '@redux-saga/core/effects';
import axios from 'axios';

import { ERROR } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';
import { retrieveFromLocalStorage } from '../../utils/util';

import { requestWaitForEvents } from './event.actions';
import { requestRetrieveShortcuts } from '../system-user/system-user.actions';
import { getWaitForEventsRequest } from './event.endpoints';
import { addSystemNotice } from '../../slices/system/system.slice';
import { setEvents } from '../../slices/event/event.slice';

export function* performWaitForEventsRequest() {
  try {
    const { events } = yield select(({ event }) => event);
    const { profile } = yield select(({ party }) => party);

    if (events && profile) {
      const lastEvent = events[events.length - 1];
      const { organisationExternalReference } = profile;
      const personExternalReference = retrieveFromLocalStorage('personExternalReference');

      const [endpoint, options] = getWaitForEventsRequest({
        eventUUID: lastEvent?.uuid,
        organisationExternalReference,
        personExternalReference,
      });

      const { data } = yield call(axios, endpoint, options);

      if (data?.events?.length > 0) {
        yield put(setEvents(data.events));

        if (data.events.some(({ type }) => type === 'Shortcut Event')) {
          yield put(requestRetrieveShortcuts());
        }
      }
    }

    yield delay(1000);
    yield put(requestWaitForEvents());
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
    yield delay(30000);
    yield put(requestWaitForEvents());
  }
}

export function* watchForWaitForEventsRequest() {
  yield takeLatest(requestWaitForEvents.type, performWaitForEventsRequest);
}

export default function* eventSaga() {
  yield all([watchForWaitForEventsRequest()]);
}
